import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Usage: wrap repeated content in a consistent surface without adding feature logic. */
@Component({
  selector: 'app-card',
  templateUrl: './app-card.component.html',
  styleUrls: ['./app-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppCardComponent {
  @Input() variant: 'standard' | 'quiet' | 'unstyled' = 'standard';
  @Input() padding: 'none' | 'sm' | 'md' = 'md';
}
